(function(angular) {
    'use strict';
    angular.module('onvio.documents').service('dmsHideTreeViewService', [
        '$q', 'bmAccess', 'dmsPermission', 'dmsModels', 'treeNavRouteModel',
        function dmsHideTreeViewService($q: any, bmAccess: any, dmsPermission: any, dmsModels: any, treeNavRouteModel: any) {
            this._treeNavRouteModel = treeNavRouteModel;
            this._dmsModels = dmsModels;
            // this only needs to be evaluated once per app lifetime
            this._hideTreeView = $q.all([
                // check IAC
                new $q(// jshint ignore:line
                    function(resolve: any) {
                        bmAccess.has('DMS_HideTreeView')
                            .then(function() { resolve(true); }).catch(function() { resolve(false); })
                            .catch(function() { resolve(false); });
                    }),
                // check FRPs
                dmsPermission.has('OnvioDrive.SuppressTree'),
            ]).then(function(toggles: any) {
                return {
                    hasHideTreeViewIac: toggles[0],
                    hasSuppressTreeFrp: toggles[1],
                    userAgent: window.navigator.userAgent,
                    IE: window.navigator.userAgent.match(/Trident/g),
                };
            });

            /**
             * @returns true if the TreeView should be hidden for the given drawerParam/DMS tab name (my/client/firm docs)
             */
            this.hideTreeView = function(): Promise<boolean> {
                return this._hideTreeView.then((toggles: any) => {

                    // show tree view unless it is suppressed or running in IE
                    const showTreeView = !toggles.hasSuppressTreeFrp && !toggles.hasHideTreeViewIac && !toggles.IE;
                    return !showTreeView;
                });
            };
        }]);
})((window as any).angular);
